import React from "react";
import { Box, Chip, Stack, Tooltip, Typography, alpha, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AGENDA_SOURCE_KEYS, getAgendaEventColors } from "./agendaUtils";

export default function AgendaLegend({ compact = false, selectedSources, onToggleSource }) {
  const { t } = useTranslation("teamAgenda");
  const theme = useTheme();
  const colors = getAgendaEventColors(theme);

  const isSelected = (key) => !selectedSources || selectedSources.has(key);

  const chipSx = (key, selected) => ({
    height: compact ? 22 : 24,
    fontSize: compact ? "0.68rem" : "0.72rem",
    fontWeight: selected ? 600 : 500,
    bgcolor: selected ? alpha(colors[key], theme.palette.mode === "dark" ? 0.18 : 0.1) : "transparent",
    color: selected ? "text.secondary" : "text.disabled",
    border: "1px solid",
    borderColor: alpha(colors[key], selected ? 0.45 : 0.22),
    opacity: selected ? 1 : 0.62,
    cursor: onToggleSource ? "pointer" : "default",
    "& .MuiChip-label": { px: 0.75 },
    "& .MuiChip-icon": { mr: -0.25 },
    "&:hover": onToggleSource
      ? {
          bgcolor: alpha(colors[key], theme.palette.mode === "dark" ? 0.24 : 0.14),
          opacity: 1,
        }
      : undefined,
  });

  return (
    <Box sx={{ px: compact ? 1.5 : 0, py: compact ? 0.75 : 1.25, mt: compact ? 0 : 0.5 }}>
      <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap sx={{ gap: 0.5 }}>
        {!compact ? (
          <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ mr: 0.5 }}>
            {t("legendTitle")}:
          </Typography>
        ) : null}
        {AGENDA_SOURCE_KEYS.map((key) => {
          const selected = isSelected(key);
          return (
          <Tooltip key={key} title={t("legendFilterHint", { source: t(`sources.${key}`) })} arrow placement="top">
            <Chip
              size="small"
              label={compact ? t(`sourcesShort.${key}`) : t(`sources.${key}`)}
              variant={selected ? "filled" : "outlined"}
              onClick={onToggleSource ? () => onToggleSource(key) : undefined}
              aria-pressed={selected}
              aria-label={t("legendFilterAria", { source: t(`sources.${key}`) })}
              icon={
                <Box
                  sx={{
                    width: compact ? 8 : 9,
                    height: compact ? 8 : 9,
                    borderRadius: "2px",
                    bgcolor: selected ? colors[key] : alpha(colors[key], 0.45),
                    ml: "6px !important",
                  }}
                />
              }
              sx={chipSx(key, selected)}
            />
          </Tooltip>
          );
        })}
      </Stack>
    </Box>
  );
}
